import clsx from "clsx";
import type { PropsWithChildren } from "react";

const InvoiceDetailsElement = ({ children, label, truncate=true }: { label: string, truncate?:boolean } & PropsWithChildren) => {
	return <div className="flex gap-4 py-2">
		<div className="w-24 shrink-0 text-sm font-light leading-6 text-gray-500">{label}</div>
		<div className={clsx("flex w-full shrink items-start font-medium leading-6 text-primary-900", truncate && "truncate")}>{children}</div>
	</div>;
};

export default InvoiceDetailsElement;